import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { StatementView, StatementMissing } from "@/components/StatementView";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/** A client's own statement, opened from their private link. Their money only. */
export default function ClientStatement() {
  const { token } = useParams();
  const [d, setD] = useState(null);
  const [gone, setGone] = useState(false);

  useEffect(() => {
    axios.get(`${API}/public/statement/${token}`).then(({ data }) => setD(data)).catch(() => setGone(true));
  }, [token]);

  if (gone) {
    return (
      <StatementMissing
        testid="statement-not-found"
        title="This statement link isn't valid"
        body="Ask your adviser to send you a fresh link."
      />
    );
  }
  if (!d) return <div className="min-h-screen flex items-center justify-center text-sm text-ink-2" data-testid="statement-loading">Loading your statement…</div>;

  return <StatementView d={d} onDownload={() => window.open(`${API}/public/statement/${token}/pdf`, "_blank")} />;
}
